export default "__VITE_ASSET__sXLG2BBH__"